import { useQuery } from '@tanstack/react-query';
import { supabase } from '../../api';

const getSearchHistory = async (userId: string | undefined) => {
  const { data: searchHistory, error: searchHistoryError } = await supabase
    .from('salons_search_history')
    .select(`*`)
    .eq('user_id', userId);

  if (searchHistoryError) {
    throw new Error(searchHistoryError.message);
  }

  return searchHistory;
};

export default function useGetSearchHistory(userId: string | undefined) {
  return useQuery({
    queryKey: ['useGetSearchHistory', userId],
    queryFn: () => getSearchHistory(userId),
    enabled: !!userId,
  });
}
